import { useTranslation } from 'react-i18next'

export const usePickByLanguage = () => {
  const { i18n } = useTranslation()

  const pickByLanguage = (value: any): string => {
    if (value && typeof value === 'object') {
      const text = value[i18n.language] || value.ja || ''
      return text.replace(/\{\{(.*?)\}\}/g, '$1')
    }
    if (value && typeof value === 'string') {
      return value
    }
    return ''
  }

  return pickByLanguage
}
